export interface KonaseemaImage {
  src: string;
  alt: string;
}

export interface KonaseemaSeason {
  name: string;
  months: string;
  icon: string;
  weather: string;
  highlights: string;
  tip: string;
  best: boolean;
}

export interface KonaseemaActivity {
  icon: string;
  title: string;
  text: string;
}

export interface KonaseemaReach {
  icon: string;
  mode: string;
  detail: string;
}

export const konaseemaIntro = [
  "Konaseema is a green delta tucked between the Godavari river and the Bay of Bengal, in the East Godavari district of Andhra Pradesh. It is a land of coconut groves, paddy fields, winding canals and quiet villages.",
  "Often called the 'Kerala of Andhra Pradesh', Konaseema moves at the pace of its waterways. Boats are as common as roads, and almost every family here is connected to the land in some way.",
  "This is where the Rythugaru journey begins — the fields, villages and farmers you meet through our experiences are all rooted in this region.",
];

export const konaseemaFacts = [
  { icon: "ri-map-2-line", label: "Region", value: "East Godavari, Andhra Pradesh" },
  { icon: "ri-ship-2-line", label: "Known for", value: "Backwaters & coconut groves" },
  { icon: "ri-sun-line", label: "Best season", value: "October to February" },
  { icon: "ri-train-line", label: "Nearest railhead", value: "Amalapuram / Rajahmundry" },
];

export const konaseemaGallery: KonaseemaImage[] = [
  {
    src: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Konaseema%20backwaters%20in%20Andhra%20Pradesh%20with%20lush%20coconut%20groves%2C%20narrow%20canals%20and%20a%20wooden%20boat%2C%20soft%20fresh%20morning%20mist%2C%20painterly%20earthy%20green%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=konaseema-hero&orientation=landscape",
    alt: "Panoramic Konaseema backwaters with coconut groves",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Serene%20green%20canal%20winding%20through%20Konaseema%20village%20with%20reflections%20of%20coconut%20palms%2C%20painterly%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1200&height=900&seq=konaseema-g1&orientation=landscape",
    alt: "Green canal winding through a Konaseema village",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20geometric%20green%20paddy%20fields%20surrounded%20by%20coconut%20groves%20in%20a%20river%20delta%2C%20painterly%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1200&height=900&seq=konaseema-g2&orientation=landscape",
    alt: "Aerial view of paddy fields in the delta",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Traditional%20South%20Indian%20village%20temple%20with%20colorful%20gopuram%20surrounded%20by%20palms%2C%20fresh%20light%2C%20painterly%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1200&height=900&seq=konaseema-g3&orientation=landscape",
    alt: "Traditional village temple surrounded by palms",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Wooden%20boat%20carrying%20villagers%20along%20a%20calm%20backwater%20canal%20at%20early%20morning%2C%20painterly%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1200&height=900&seq=konaseema-g4&orientation=landscape",
    alt: "Wooden boat on a calm backwater canal",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Farmer%20walking%20on%20a%20narrow%20bund%20between%20green%20paddy%20fields%20in%20Konaseema%2C%20soft%20morning%20light%2C%20painterly%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1200&height=900&seq=konaseema-g5&orientation=landscape",
    alt: "Farmer walking on a bund between paddy fields",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Fresh%20coconut%20and%20local%20Andhra%20meal%20arranged%20on%20a%20banana%20leaf%20near%20the%20backwaters%2C%20fresh%20tones%2C%20painterly%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1200&height=900&seq=konaseema-g6&orientation=landscape",
    alt: "Local Andhra meal served on a banana leaf",
  },
];

export const konaseemaBandImages: KonaseemaImage[] = [
  {
    src: "https://readdy.ai/api/search-image?query=Golden%20sunrise%20over%20a%20wide%20Konaseema%20backwater%20with%20silhouetted%20coconut%20palms%20and%20a%20lone%20wooden%20fishing%20boat%2C%20warm%20reflections%20on%20emerald%20water%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&width=1000&height=800&seq=konaseema-band-1&orientation=landscape",
    alt: "Golden sunrise over a Konaseema backwater with palms and a fishing boat",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20patchwork%20of%20emerald%20paddy%20fields%20crisscrossed%20by%20winding%20canals%20in%20the%20Godavari%20delta%20glowing%20under%20warm%20dawn%20light%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&width=1000&height=800&seq=konaseema-band-2&orientation=landscape",
    alt: "Aerial view of emerald paddy fields and canals in the Godavari delta",
  },
  {
    src: "https://readdy.ai/api/search-image?query=A%20narrow%20green%20canal%20lined%20with%20dense%20coconut%20palms%20with%20golden%20sunrays%20streaming%20through%20the%20fronds%20in%20Konaseema%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&width=1000&height=800&seq=konaseema-band-3&orientation=landscape",
    alt: "Narrow green canal lined with coconut palms with sunrays through the fronds",
  },
  {
    src: "https://readdy.ai/api/search-image?query=A%20South%20Indian%20village%20woman%20carrying%20a%20woven%20basket%20walking%20along%20a%20bund%20beside%20a%20Konaseema%20canal%20at%20sunrise%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&width=1000&height=800&seq=konaseema-band-4&orientation=landscape",
    alt: "Village woman carrying a basket along a Konaseema canal at sunrise",
  },
  {
    src: "https://readdy.ai/api/search-image?query=A%20lush%20banana%20and%20coconut%20plantation%20beside%20a%20reflective%20village%20pond%20in%20Konaseema%20bathed%20in%20warm%20golden%20morning%20light%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&width=1000&height=800&seq=konaseema-band-5&orientation=landscape",
    alt: "Banana and coconut plantation beside a pond in warm golden light",
  },
];

export const konaseemaSeasons: KonaseemaSeason[] = [
  {
    name: "Winter",
    months: "October – February",
    icon: "ri-snowy-line",
    weather: "Pleasant and cool, 18°C – 30°C",
    highlights: "Best time for field walks, boating, village tours and festivals.",
    tip: "This is our most recommended window — book early as it fills fast.",
    best: true,
  },
  {
    name: "Summer",
    months: "March – May",
    icon: "ri-sun-line",
    weather: "Hot and humid, 30°C – 42°C",
    highlights: "Mango season, early-morning farm visits and shaded grove walks.",
    tip: "Start experiences at sunrise and rest in the afternoons. Carry plenty of water.",
    best: false,
  },
  {
    name: "Monsoon",
    months: "June – September",
    icon: "ri-rainy-line",
    weather: "Warm and wet, 25°C – 34°C",
    highlights: "Lush green fields, paddy planting, full canals and dramatic skies.",
    tip: "Paddy transplanting is happening — perfect for the Farmer for a Day experience.",
    best: false,
  },
];

export const konaseemaActivities: KonaseemaActivity[] = [
  {
    icon: "ri-ship-2-line",
    title: "Backwater Boating",
    text: "Glide along calm canals lined with coconut palms and watch village life pass by on the water.",
  },
  {
    icon: "ri-road-map-line",
    title: "Coconut Grove Walks",
    text: "Wander shaded groves, learn how coconut is harvested and sip fresh tender coconut.",
  },
  {
    icon: "ri-plant-line",
    title: "Paddy Field Trails",
    text: "Walk the narrow bunds between bright green fields and understand the delta's farming cycle.",
  },
  {
    icon: "ri-ancient-gate-line",
    title: "Temple & Heritage Visits",
    text: "Discover centuries-old temples, local legends and the region's rich cultural roots.",
  },
  {
    icon: "ri-restaurant-2-line",
    title: "Andhra Village Food",
    text: "Taste fiery local curries, palm toddy, fresh fish and the region's famous coconut-based dishes.",
  },
  {
    icon: "ri-store-2-line",
    title: "Village Markets",
    text: "Browse weekly markets full of fresh produce, handmade goods and the buzz of rural commerce.",
  },
];

export const konaseemaReach: KonaseemaReach[] = [
  {
    icon: "ri-plane-line",
    mode: "By Air",
    detail: "Nearest airport is Rajahmundry (RJA), about 1.5–2 hours by road. Visakhapatnam (VTZ) is a longer 4–5 hour drive.",
  },
  {
    icon: "ri-train-line",
    mode: "By Train",
    detail: "Amalapuram and Rajahmundry are the closest railheads, both well connected to major South Indian cities.",
  },
  {
    icon: "ri-roadster-line",
    mode: "By Road",
    detail: "Konaseema is around 60 km from Rajahmundry and 200 km from Vijayawada, with scenic delta roads throughout.",
  },
  {
    icon: "ri-ship-line",
    mode: "Local Travel",
    detail: "Once here, boats and auto-rickshaws are the best way to move between villages and canal-side farms.",
  },
];

export const konaseemaMapEmbed =
  "https://www.google.com/maps?q=Konaseema,East%20Godavari,Andhra%20Pradesh,India&z=10&output=embed";